import React from 'react'
import './CareerTestResult.css';
import RISAECgraph from '../../assets/img/distribution.png';

function PassionResult({ id,scores }) {
    const resultsText = [];
    resultsText[0] = "Creating or Building";
    resultsText[1] = "Teaching";
    resultsText[2] = "Nature";
    resultsText[3] = "Art or Music";
    resultsText[4] = "Film or Television";
    resultsText[5] = "Volunteering";
    resultsText[6] = "";
    resultsText[7] = "";

    const resultsDesc = [];
    resultsDesc[0] = "You love working with your hands and creating things. Whether it is constructing houses or crafting, making something from nothing is what makes you happy. You should start a career or hobby selling your handmade goods at fairs or opening an Etsy store.";
    resultsDesc[1] = "You are at your happiest when you are helping others learn new things. Your ability to pass along your knowledge to others makes you a perfect teacher. If you could not find a position as a full-time teacher, maybe a part time position at the senior center or learning annex would help you get the happiness you deserve.";
    resultsDesc[2] = "Being in and protecting the environment is your true passion. A career as a park ranger or lifeguard, would keep you away from a desk and more importantly keep you happy. There are also plenty of opportunities to act as a tour guide in our national parks or to lead local cleaning efforts to keep nature pristine and beautiful.";
    resultsDesc[3] = "Your true passion lies in creating beauty for others to enjoy. While it might be difficult to make it big in the art or music industry, that should not stop you from spending your nights and weekends pursuing your true passion.";
    resultsDesc[4] = "While many don't consider watching TV a hobby, you understand the passion and dedication it takes for those things to be created. You need to channel that inner creativity you have and produce entertainment for others to enjoy. It is never too late to work on a screen play, or to join an improv group.";
    resultsDesc[5] = "Maybe you are havening a hard time finding your true passion, because your passion is not a single hobby or job. Your passion is helping others and expecting nothing in return. A job with a non-profit or a corporation known for its social justice would ignite your inner passion.";
    resultsDesc[6] = "";
    resultsDesc[7] = "";

    const pictures = [];
    pictures[0] = "https://www.quizony.com/what-is-my-passion/imageForSharing.jpg";
    pictures[1] = "https://www.quizony.com/what-is-my-passion/imageForSharing.jpg";
    pictures[2] = "https://www.quizony.com/what-is-my-passion/imageForSharing.jpg";
    pictures[3] = "https://www.quizony.com/what-is-my-passion/imageForSharing.jpg";
    pictures[4] = "https://www.quizony.com/what-is-my-passion/imageForSharing.jpg";
    pictures[5] = "https://www.quizony.com/what-is-my-passion/imageForSharing.jpg";
    pictures[6] = "";
    pictures[7] = "";

    const quizName = "What Is My Passion?";
    return (
        <div className='testResults__container'>
            <div className="jumboPad result_bkg text-center">
                <h3 className="resultStart">You should start a career in</h3>

                <h1 id="result" className="realResult result_title">{resultsText[id]}</h1>

                <h5 id="resultDescription" className="resultDesc">{resultsDesc[id]}</h5>
                <br />


            </div>
        </div >
    )
}

export default PassionResult